import { useTranslation } from '@pypestream/translations';
import {
  AppErrorBoundary,
  resolveErrorFlags,
  type ChildrenProps,
} from '@pypestream/ui-patterns';
import { isDevelopment } from '@pypestream/utils';
import { FC } from 'react';

import {
  useCurrentState,
  useManagerCtxSelector,
} from '../../xstate/app.xstate';

/**
 * Manager's root error boundary.
 *
 * The twin of Pro Studio's: only the XState hooks and the translation scope
 * differ. `onChunkError` is deliberately not passed — auto-reloading on a stale
 * chunk is a Pro Studio product decision, and turning it on here needs its own.
 */
export const ErrorBoundary: FC<ChildrenProps> = ({ children }) => {
  const [t] = useTranslation();
  const currentState = useCurrentState();
  const errors = useManagerCtxSelector((ctx) => ctx.errors);

  return (
    <AppErrorBoundary
      errors={errors}
      flags={resolveErrorFlags(Object.values(currentState))}
      isDevelopment={isDevelopment}
      labels={{
        body: String(t('manager/common:errorBoundary.pageNotFound')),
        reload: String(t('manager/common:errorBoundary.reloadPage')),
        home: String(t('manager/common:errorBoundary.goHome')),
      }}
    >
      {children}
    </AppErrorBoundary>
  );
};
